import React, { useState } from 'react';
import { useAnalytics } from '@carvana/analytics';
import { Link } from 'gatsby';
import deepmerge from 'deepmerge';
import Breadcrumb from '../../breadcrumb';
import { ArticleHelpful } from '../article-helpful';
import { useArticleContext } from '../context';
import {
  SectionWrapper,
  InnerSectionWrapper,
  ArticleName,
  ContentWrapper,
  ArticleLoadingContent
} from './article-content.syles';
import { SendInViewEvent } from '../../../helpers/send-in-view-event';
import ArticleRenderer from '@carvana/article-renderer';

const AnalyticEvents = ({ trackEvent, data }) => {
  trackEvent('cjs_signal', { clickstream: { data } }, ['clickstream']);
};

// Work-around for custom components that trigger reloads, and we have no control over
// There is an miscommunication between components that useEffect, and the inView func that causes reloads.
const hasCustomComponentThatTriggersReload = ({ article_content } = {}) => {
  const listOfCustomComponentsThatMightMiscommunicateAndTriggerAReloadOnArticlePage = [
    'DeliveryOrPickup'
  ];
  const areAnyOfTheCustomComponentsThatMightMiscommunicateAndTriggerAReloadInsideOfArticleContent = listOfCustomComponentsThatMightMiscommunicateAndTriggerAReloadOnArticlePage.some(
    (componentName) => article_content?.indexOf(componentName) >= 0
  );
  return areAnyOfTheCustomComponentsThatMightMiscommunicateAndTriggerAReloadInsideOfArticleContent;
};

export const ArticleContent = () => {
  const { strapiArticle, user, isLoading } = useArticleContext() || {};
  const { trackEvent } = useAnalytics();
  const { topic: { topic_name, topic_url } = {}, article_content, article_name } = strapiArticle;
  const [externalData, setExternalData] = useState({});
  const externalCallback = (cb) => cb(setExternalData);

  const userData = deepmerge(
    {
      date: new Date().toISOString(),
      user: {
        ...user,
        profile: {
          ...(user?.profile || {}),
          address: {
            verifiedDelivery: user?.profile?.address?.filter(
              (x) => x?.kind?.toLowerCase() === 'verifieddelivery'
            )[0]?.address,
            verifiedHome: user?.profile?.address?.filter(
              (x) => x?.kind?.toLowerCase() === 'verifiedhome'
            )[0]?.address,
            verifiedRegistration: user?.profile?.address?.filter(
              (x) => x?.kind?.toLowerCase() === 'verifiedregistration'
            )[0]?.address
          }
        }
      },
      article: strapiArticle
    },
    externalData
  );

  if (!isLoading) AnalyticEvents({ trackEvent, data: userData });
  const [ref] = SendInViewEvent({
    isLoading,
    component_name: 'article_content',
    data: { userData, strapiArticle },
    triggerOnce: hasCustomComponentThatTriggersReload({ article_content })
  });

  const renderedArticle =
    strapiArticle &&
    ArticleRenderer.render(article_content, userData, null, { TempGatsbyUrlLink: Link });

  return (
    <SectionWrapper ref={ref}>
      <InnerSectionWrapper>
        <Breadcrumb name={topic_name} url={topic_url} />

        <ArticleName>{article_name}</ArticleName>

        <ContentWrapper>
          {isLoading ? <ArticleLoadingContent /> : <>{renderedArticle}</>}
        </ContentWrapper>

        <ArticleHelpful />
      </InnerSectionWrapper>
    </SectionWrapper>
  );
};
